import React, { useState } from 'react';
import slide1 from '../Assets/slide1.jpg';
import slide2 from '../Assets/slide2.jpg';
import parant from '../Assets/parant.svg';
import tree from '../Assets/tree.svg';
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi';
import { Parallax, ParallaxProvider } from 'react-scroll-parallax';
import { Link } from 'react-router-dom';
const Slide = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [activeFeature, setActiveFeature] = useState(0);

  const slides = [slide1, slide2];

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides?.length);
  };


  const handleFeatureClick = (index) => {
    setActiveFeature(index);
  };

  return (
    <ParallaxProvider>
      <div className="flex flex-col lg:flex-row mt-16 relative items-center lg:items-start overflow-auto">

        {/* Left Half: Image Slider */}
        <div className="w-full lg:w-1/2 flex items-center justify-center relative">
          <svg
            viewBox="0 0 200 200"
            xmlns="http://www.w3.org/2000/svg"
            className="w-[80%] sm:w-[90%] h-auto"
          >
            <defs>
              <clipPath id="blobShape">
                <path
                  fill="#FF0066"
                  d="M44.7,-58.5C57.8,-52.1,68,-38.8,75.4,-22.9C82.8,-7,87.3,11.4,82.4,26.9C77.6,42.4,63.3,54.9,48,61.8C32.6,68.6,16.3,69.9,1.1,68.4C-14.2,67,-28.4,62.8,-43.3,55.8C-58.2,48.8,-73.9,38.9,-78.2,25.5C-82.4,12,-75.4,-5.1,-69.9,-22.9C-64.3,-40.6,-60.3,-59,-48.9,-66C-37.5,-73,-18.7,-68.6,-1.4,-66.6C15.8,-64.6,31.7,-65,44.7,-58.5Z"
                  transform="translate(100 100)"
                />

              </clipPath>
            </defs>
            <image
              href={slides[currentSlide]}
              width="200"
              height="200"
              clipPath="url(#blobShape)"
              preserveAspectRatio="xMidYMid slice" />
          </svg>
          <button
            onClick={prevSlide}
            className="absolute left-4 sm:left-10 lg:left-14 text-[#e84c24] p-2 rounded-l"
          >
            <FiChevronLeft className="h-6 w-6" />
          </button>
          <button
            onClick={nextSlide}
            className="absolute right-4 sm:right-10 lg:right-14 text-[#e84c24] p-2 rounded-r"
          >
            <FiChevronRight className="h-6 w-6" />

          </button>

        </div>
        <div className="w-full lg:w-[25%] mt-5 lg:mt-20   flex justify-center lg:justify-start relative">
          <ol className="text-white font-semibold py-20">
            {[...Array(4).keys()].map((index) => (
              <li
                key={index}
                className={`flex items-center   text-[#16bab1] cursor-pointer transition-transform duration-300 ${activeFeature === index ? 'scale-105' : ''
                  }`}
                onClick={() => handleFeatureClick(index)}
              >
                <svg
                  viewBox="0 0 200 200"
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-[60px] sm:w-[80px] h-auto"
                >
                  <path
                    fill={activeFeature === index ? '#e84c24' : '#167286'}
                    d="M36.8,20C25.5,40.9,-21.2,40.1,-33.3,18.7C-45.3,-2.6,-22.7,-44.4,0.7,-44C24.1,-43.6,48.1,-0.9,36.8,20Z"
                    transform="translate(100 100)"
                  />
                  <text
                    x="50%"
                    y="50%"
                    textAnchor="middle"
                    dy=".3em"
                    fill="#ffffff"
                    className="font-bold text-sm sm:text-xl"
                  >
                    {index + 1}
                  </text>
                </svg>
                <span
                  className={`ml-1 sm:ml-2 text-sm sm:text-lg navbar-link font-sans ${activeFeature === index ? 'text-[#e84c24] font-bold' : 'text-[#167286]'
                    }`}
                >
                  {index === 0 && 'Home like environment'}
                  {index === 1 && 'Safety and Secure'}
                  {index === 2 && 'Personalized attention '}
                  {index === 3 && 'Social Skill building'}
                </span>
              </li>
            ))}
          </ol>
        </div>

        {/* Parallax Section */}
        <div className="w-full lg:w-[12%] mt-6 lg:mt-36 flex justify-center lg:justify-start">
          <div>
            <Parallax translateX={[30, -30]}>
              <img src={parant} alt="" />
            </Parallax>
            <Link to="about">
              <button
                className=" px-4 py-2 border border-[#16bab1]   text-[#16bab1]  rounded-lg  transition"
              >
                Learn more
              </button>
            </Link>
          </div>
        </div>
        {/* Tree Icon */}
        <div className="w-full lg:w-[12%]  absolute top-[820px] lg:top-[300px] -right-6 hidden lg:block lg:right-12 flex justify-center">
          <img src={tree} alt="TREE" className="h-[80px] sm:h-[120px]" />
        </div>



      </div>

    </ParallaxProvider>

  );
};

export default Slide;
